import React, { useState } from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';
import { NavLink } from 'react-router-dom';
import './Quiz.css';
import { IconContext } from 'react-icons';

const SidebarData = [
  {
    title: 'Home',
    path: '/quiz',
    icon: <AiIcons.AiFillHome />,
  },
  {
    title: 'Matrices',
    path: '/quiz/matrices',
    icon: <IoIcons.IoIosBook />,
  },
  {
    title: 'Determinants',
    path: '/quiz/determinants',
    icon: <IoIcons.IoIosBook />,
  },
];

export default function Quiz() {
  const [sidebar, setSidebar] = useState(false);

  const showSidebar = () => setSidebar(!sidebar);

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <div className='navbar flex items-center justify-start bg-background'>
          <NavLink to='#' className='menu-bars bg-none'>
            <FaIcons.FaBars onClick={showSidebar} />
          </NavLink>
          <div className='heading text-snow-storm-white text-4xl'>
            <NavLink to="/">Mafs</NavLink>
          </div>
        </div>
        <nav className={sidebar ? 'nav-menu active' : 'nav-menu'}>
          <ul className='w-full' onClick={showSidebar}>
            <li className='navbar-toggle flex items-center justify-start bg-background w-full h-20'>
              <NavLink to='#' className='menu-bars bg-none'>
                <AiIcons.AiOutlineClose />
              </NavLink>
            </li>
            {SidebarData.map((item, index) => {
              return (
                <li key={index} className="nav-text flex items-center justify-start list-none">
                  <NavLink to={item.path}>
                    {item.icon}
                    <span>{item.title}</span>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>
      </IconContext.Provider>
      <h1 className="dummy text-4xl text-white"> Come Back Later! </h1>
    </>
  );
}